var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoggingAndMonitoring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 30",
    viewBox: "0 0 32 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#5596e6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29 16.2c-2.2 2.5-7.9 8.1-13.6 8.1-7.3 0-14.6-9.3-14.6-9.3s7.3-9.3 14.6-9.3c5.7 0 11.3 5.6 13.6 8.1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.4,
    cy: 15.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 12.8-5.2-9.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 15.1h10.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.1 17.4-5.4 9.2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.8,
    cy: 15.2,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.1,
    cy: 2.5,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.1,
    cy: 27.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.4,
    cy: 15.1,
    r: 2.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggingAndMonitoring);
export default __webpack_public_path__ + "../static/product-explorer/assets/logging-and-monitoring.7c2cbd83374e518b23e2c32d291106dd.svg";
export { ForwardRef as ReactComponent };